export interface ICategory {
  id: number | null;
  name: string | null;
  imageId: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
}

export type ICategoryList = ICategory[];

export interface IBrand {
  id: number | null;
  name: string | null;
  imageId: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
}

export type IBrands = IBrand[];

export interface IProductLine {
  id: number | null;
  name: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
}

export type IProductsLine = IProductLine[];

export interface ISpecs {
  id: number;
  name: string;
  value: string[];
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export enum PRODUCT_CATEGORY {
  LAPTOP = 'Laptops',
  CELLPHONES = 'Celulares',
  MONITORS = 'Monitores',
  DESKS = 'Escritorios',
  CHAIRS = 'Sillas',
  ACCESSORIES = 'Accesorios',
  PRINTERS = 'Impresoras',
  PC = 'PC',
  FURNITURE = 'Mobiliario',
  DEP_LAPTOPS = 'Laptops con DEP',
  CTO_LAPTOPS = 'Laptops CTOs'
}
